function mapGetOneImportUsersHistoryData(responseData) {
    return {
        ...responseData,
    };
}

function mapGetListImportUsersHistoriesData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export { mapGetOneImportUsersHistoryData, mapGetListImportUsersHistoriesData };
